export default __webpack_public_path__ + "static/media/opera.7d0c7f16.svg";